var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          staticClass: "bill-dialog",
          attrs: {
            id: "operateApp",
            visible: _vm.innerVisible,
            title: _vm.$t("CargoMsg.Cargo_DomesticBill"),
            fullscreen: true,
            width: "auto",
            "close-on-press-escape": false,
            "modal-append-to-body": false,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              style:
                "min-width: 1600px;" +
                (_vm.expandedGrid
                  ? "height: 100%;display: flex;flex-direction: column;"
                  : "")
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.expandedGrid,
                      expression: "!expandedGrid"
                    }
                  ],
                  staticClass: "app-main-inner-row bill-dialog-form-wrapper"
                },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "bill-form-content",
                      attrs: {
                        "label-position": "left",
                        "label-width": _vm.isZh ? "85px" : "135px",
                        model: _vm.billing
                      }
                    },
                    [
                      _c(
                        "el-row",
                        { attrs: { gutter: 5, type: "flex" } },
                        [
                          _c(
                            "el-col",
                            {
                              staticStyle: { width: "630px" },
                              attrs: { span: 8 }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "section",
                                  staticStyle: { flex: "1", height: "100%" }
                                },
                                [
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_BillNo"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: true,
                                              no: "billingNo"
                                            },
                                            model: {
                                              value: _vm.billing.billingNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "billingNo",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.billingNo"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_SettleAccountsTo"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              filterable: "",
                                              no: "settlement",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Company,
                                              "method-params": {
                                                customer: true,
                                                active: true
                                              },
                                              "tag-name": _vm.isZh
                                                ? "chineseName"
                                                : "englishName",
                                              "default-value":
                                                _vm.billing.accountId,
                                              clearable: false
                                            },
                                            on: {
                                              parentCallBack: _vm.accountChange
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_SettlementAgent"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              filterable: "",
                                              no: "settlementAgent",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .basic_data_Company,
                                              "default-value":
                                                _vm.billing.settlementAgentId,
                                              disabled: _vm.accountDisable,
                                              "method-params": {
                                                auto_accountId: true
                                              },
                                              cache: false,
                                              clearable: false,
                                              "tag-name": _vm.isZh
                                                ? "chineseName"
                                                : "englishName",
                                              "static-options":
                                                _vm.settlementAgentArray
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.settlementAgentChange
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_InvoiceHeader"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .static_data_Title,
                                              no: "invoiceTitleUuid",
                                              "allow-create": !_vm.config
                                                .arSettlementUnitOptional,
                                              filterable: "",
                                              cache: false,
                                              "default-value":
                                                _vm.billing.invoiceTitleUuid,
                                              disabled: _vm.accountDisable,
                                              "tag-value": "uuid",
                                              "static-options": _vm.titleArray
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.titleChangeEvent
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "Partners.CustomerMailbox"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: _vm.accountDisable,
                                              no: "customerEmail"
                                            },
                                            model: {
                                              value: _vm.billing.customerEmail,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "customerEmail",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.customerEmail"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_RegistrationAddress"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "buyerAddress" },
                                            model: {
                                              value: _vm.billing.buyerAddress,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "buyerAddress",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.buyerAddress"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { staticClass: "inline" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_RegistrationNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: true,
                                              no: "buyerTaxAccount"
                                            },
                                            model: {
                                              value:
                                                _vm.billing.buyerTaxAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "buyerTaxAccount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.buyerTaxAccount"
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t("CargoMsg.Cargo_Tel")
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: { no: "buyerTelephone" },
                                            model: {
                                              value: _vm.billing.buyerTelephone,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "buyerTelephone",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.buyerTelephone"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { staticClass: "inline" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_DepositBank"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              filterable: "",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .static_data_TitleBank,
                                              no: "titleBankUuid",
                                              "default-value":
                                                _vm.billing.titleBankUuid,
                                              cache: false,
                                              "tag-value": "uuid",
                                              "static-options":
                                                _vm.titleBankArray
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.getBankCusFromChild
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_AccountNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: true,
                                              no: "buyerBankAccount"
                                            },
                                            model: {
                                              value:
                                                _vm.billing.buyerBankAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "buyerBankAccount",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.buyerBankAccount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_RevenueAndExpenditureType"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: true,
                                              no: "ar",
                                              value: _vm.billing.arValue
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    { staticClass: "inline" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_OwnerBankOfDeposit"
                                            )
                                          }
                                        },
                                        [
                                          _c("cargo-advance-select", {
                                            attrs: {
                                              filterable: "",
                                              cache: false,
                                              no: "bankAccountId",
                                              "select-type":
                                                _vm.selectTypeNames
                                                  .static_data_BankAccount,
                                              "default-value":
                                                _vm.billing.bankAccountId === 0
                                                  ? ""
                                                  : _vm.billing.bankAccountId,
                                              "static-options":
                                                _vm.ourBankAccountArray
                                            },
                                            on: {
                                              parentCallBack:
                                                _vm.getOurBankAccountFromChild
                                            }
                                          })
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_AccountNumber"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              disabled: true,
                                              no: "bankAccount"
                                            },
                                            model: {
                                              value: _vm.billing.bankAccount,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "bankAccount",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.bankAccount"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_BillDate"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              no: "inputDate",
                                              type: "date",
                                              clearable: false,
                                              editable: false,
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            on: { change: _vm.inputDateChange },
                                            model: {
                                              value: _vm.billing.inputDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "inputDate",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.inputDate"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_DueDate"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-date-picker", {
                                            staticStyle: { width: "100%" },
                                            attrs: {
                                              no: "dueDate",
                                              type: "date",
                                              clearable: false,
                                              editable: false,
                                              format: "yyyy-MM-dd",
                                              "value-format": "yyyy-MM-dd"
                                            },
                                            model: {
                                              value: _vm.billing.dueDate,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "dueDate",
                                                  $$v
                                                )
                                              },
                                              expression: "billing.dueDate"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_AgentBillNo"
                                            )
                                          }
                                        },
                                        [
                                          _c("el-input", {
                                            attrs: {
                                              no: "counterPartyBillingNo"
                                            },
                                            model: {
                                              value:
                                                _vm.billing
                                                  .counterPartyBillingNo,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  _vm.billing,
                                                  "counterPartyBillingNo",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "billing.counterPartyBillingNo"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.billingNoteContainInvoice,
                                          expression:
                                            "!billingNoteContainInvoice"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "Invoice.invoice_invoiceCategory"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                no: "invoiceMakeType",
                                                placeholder: _vm.$t(
                                                  "CargoMsg.Cargo_PleaseSelect"
                                                ),
                                                clearable: ""
                                              },
                                              on: {
                                                change:
                                                  _vm.changeInvoiceMakeType
                                              },
                                              model: {
                                                value:
                                                  _vm.billing.invoiceMakeType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billing,
                                                    "invoiceMakeType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billing.invoiceMakeType"
                                              }
                                            },
                                            _vm._l(
                                              _vm.invoiceMakeTypes,
                                              function(item, index) {
                                                return _c("el-option", {
                                                  key: index,
                                                  attrs: {
                                                    label: item.chineseName,
                                                    value: item.code
                                                  }
                                                })
                                              }
                                            ),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: !_vm.billingNoteContainInvoice,
                                          expression:
                                            "!billingNoteContainInvoice"
                                        }
                                      ]
                                    },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "CargoMsg.Cargo_InvoiceType"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                no: "invoiceType",
                                                placeholder: _vm.$t(
                                                  "CargoMsg.Cargo_PleaseSelect"
                                                ),
                                                clearable: ""
                                              },
                                              model: {
                                                value: _vm.billing.invoiceType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billing,
                                                    "invoiceType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billing.invoiceType"
                                              }
                                            },
                                            _vm._l(_vm.invoiceTypes, function(
                                              item,
                                              index
                                            ) {
                                              return _c("el-option", {
                                                key: index,
                                                attrs: {
                                                  label: item.chineseName,
                                                  value: item.code
                                                }
                                              })
                                            }),
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "el-col",
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          attrs: {
                                            label: _vm.$t(
                                              "Billing.billingJob_settlementType"
                                            )
                                          }
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              attrs: {
                                                no: "settlementType",
                                                disabled: _vm.accountDisable
                                              },
                                              model: {
                                                value:
                                                  _vm.billing.settlementType,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billing,
                                                    "settlementType",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billing.settlementType"
                                              }
                                            },
                                            [
                                              _vm.billing.settlementType === 0
                                                ? _c("el-option", {
                                                    key: -1,
                                                    attrs: {
                                                      label: " ",
                                                      value: 0
                                                    }
                                                  })
                                                : _vm._e(),
                                              _vm._l(
                                                _vm.SETTLEMENT_TYPE_STATES,
                                                function(item, index) {
                                                  return _c("el-option", {
                                                    key: index,
                                                    attrs: {
                                                      label: _vm.$store.getters
                                                        .isZh
                                                        ? item.chineseName
                                                        : item.englishName,
                                                      value: item.code
                                                    }
                                                  })
                                                }
                                              )
                                            ],
                                            2
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.config.billingNoteContainInvoiceReques
                                    ? _c(
                                        "el-col",
                                        [
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  "CargoMsg.Cargo_InvoicingType"
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  attrs: {
                                                    no: "makeInvoiceType",
                                                    disabled:
                                                      _vm.accountDisable,
                                                    placeholder: ""
                                                  },
                                                  on: {
                                                    change:
                                                      _vm.makeInvoiceTypeChange
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.billing
                                                        .makeInvoiceType,
                                                    callback: function($$v) {
                                                      _vm.$set(
                                                        _vm.billing,
                                                        "makeInvoiceType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "billing.makeInvoiceType"
                                                  }
                                                },
                                                [
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "CargoMsg.Cargo_LotteryDraw"
                                                      ),
                                                      value: 0
                                                    }
                                                  }),
                                                  _c("el-option", {
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "CargoMsg.Cargo_SchoolMonth"
                                                      ),
                                                      value: 1
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.billingNoteContainInvoice
                                    ? _c(
                                        "el-col",
                                        [
                                          _c(
                                            "el-checkbox",
                                            {
                                              on: {
                                                change:
                                                  _vm.detailMakeInvoiceChange
                                              },
                                              model: {
                                                value:
                                                  _vm.billing.detailMakeInvoice,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billing,
                                                    "detailMakeInvoice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billing.detailMakeInvoice"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_DetailMakeInvoice"
                                                  )
                                                )
                                              )
                                            ]
                                          ),
                                          _c(
                                            "el-checkbox",
                                            {
                                              model: {
                                                value:
                                                  _vm.billing.splitMakeInvoice,
                                                callback: function($$v) {
                                                  _vm.$set(
                                                    _vm.billing,
                                                    "splitMakeInvoice",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "billing.splitMakeInvoice"
                                              }
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "CargoMsg.Cargo_SplitMakeInvoice"
                                                  )
                                                )
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.billingNoteContainInvoice &&
                                  !_vm.billing.detailMakeInvoice
                                    ? _c(
                                        "el-col",
                                        [
                                          _c("cargo-ag-grid", {
                                            staticStyle: {
                                              width: "100%",
                                              height: "100px"
                                            },
                                            attrs: {
                                              "grid-params":
                                                _vm.invoiceGoodsName.gridParams,
                                              "grid-options":
                                                _vm.invoiceGoodsName
                                                  .gridOptions,
                                              "column-defs":
                                                _vm.invoiceGoodsNameColumnDefs,
                                              "row-data":
                                                _vm.billing
                                                  .billingBeforehandVOS,
                                              "min-height": "100px"
                                            },
                                            on: {
                                              "update:gridParams": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.invoiceGoodsName,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              "update:grid-params": function(
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.invoiceGoodsName,
                                                  "gridParams",
                                                  $event
                                                )
                                              },
                                              gridReady: function(params) {
                                                return (_vm.invoiceGoodsName.gridApi =
                                                  params.api)
                                              }
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ]
                          ),
                          _c(
                            "el-col",
                            { staticStyle: { flex: "1" }, attrs: { span: 16 } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "section",
                                  staticStyle: { flex: "1", height: "100%" }
                                },
                                [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "el-col",
                                        {
                                          staticStyle: { width: "550px" },
                                          attrs: { span: 10 }
                                        },
                                        [
                                          _c(
                                            "el-col",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_OriginalCurrency2"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_Amount"
                                                      )
                                                    )
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "CargoMsg.Cargo_ExchangeRate2"
                                                      )
                                                    )
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100px"
                                                        },
                                                        attrs: {
                                                          disabled: true,
                                                          no: "sourceCurrency1"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing
                                                              .sourceCurrency1,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "sourceCurrency1",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.sourceCurrency1"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          no: "amount1",
                                                          "controls-position":
                                                            "right",
                                                          min: -999999999999,
                                                          max: 999999999999,
                                                          precision: 2,
                                                          disabled: true
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing.amount1,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "amount1",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.amount1"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("num-input", {
                                                        attrs: {
                                                          no: "sourceRate1",
                                                          min: 0,
                                                          max: 999999999,
                                                          precision: 8,
                                                          "truncated-precision":
                                                            _vm.sourceRate1Precision,
                                                          disabled:
                                                            _vm.formParams
                                                              .sourceRate1Enable
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.calculateAmount
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing
                                                              .sourceRate1,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "sourceRate1",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.sourceRate1"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100px"
                                                        },
                                                        attrs: {
                                                          no: "sourceCurrency2",
                                                          disabled: true
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing
                                                              .sourceCurrency2,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "sourceCurrency2",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.sourceCurrency2"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          no: "amount2",
                                                          "controls-position":
                                                            "right",
                                                          min: -999999999999,
                                                          max: 999999999999,
                                                          precision: 2,
                                                          disabled: true
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing.amount2,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "amount2",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.amount2"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("num-input", {
                                                        attrs: {
                                                          no: "sourceRate2",
                                                          min: 0,
                                                          max: 999999999,
                                                          precision: 8,
                                                          "truncated-precision":
                                                            _vm.sourceRate2Precision,
                                                          disabled:
                                                            _vm.formParams
                                                              .sourceRate2Enable
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.calculateAmount
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing
                                                              .sourceRate2,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "sourceRate2",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.sourceRate2"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input", {
                                                        staticStyle: {
                                                          width: "100px"
                                                        },
                                                        attrs: {
                                                          disabled: true,
                                                          no: "sourceCurrency3"
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing
                                                              .sourceCurrency3,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "sourceCurrency3",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.sourceCurrency3"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("el-input-number", {
                                                        attrs: {
                                                          no: "amount3",
                                                          "controls-position":
                                                            "right",
                                                          min: -999999999999,
                                                          max: 999999999999,
                                                          precision: 2,
                                                          disabled: true
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing.amount3,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "amount3",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.amount3"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              ),
                                              _c(
                                                "el-col",
                                                { attrs: { span: 8 } },
                                                [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      attrs: {
                                                        "label-width": "0"
                                                      }
                                                    },
                                                    [
                                                      _c("num-input", {
                                                        attrs: {
                                                          no: "sourceRate3",
                                                          min: 0,
                                                          max: 999999999,
                                                          precision: 8,
                                                          "truncated-precision":
                                                            _vm.sourceRate3Precision,
                                                          disabled:
                                                            _vm.formParams
                                                              .sourceRate3Enable
                                                        },
                                                        on: {
                                                          change:
                                                            _vm.calculateAmount
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.billing
                                                              .sourceRate3,
                                                          callback: function(
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.billing,
                                                              "sourceRate3",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "billing.sourceRate3"
                                                        }
                                                      })
                                                    ],
                                                    1
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        { attrs: { span: 6 } },
                                        [
                                          _c(
                                            "el-col",
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_BillingCurrency"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    attrs: {
                                                      filterable: "",
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .basic_data_Currency,
                                                      no: "currency",
                                                      "default-value":
                                                        _vm.billing.currency,
                                                      clearable: false
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.currencyChangeEvent
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Billing.billingForm_taxAmount"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      no: "amount",
                                                      "controls-position":
                                                        "right",
                                                      min: -999999999999,
                                                      max: 999999999999,
                                                      precision: 2,
                                                      disabled: true
                                                    },
                                                    model: {
                                                      value: _vm.billing.amount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.billing,
                                                          "amount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "billing.amount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "Billing.billingForm_taxFreeAmount"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input-number", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      no: "taxFreeAmount",
                                                      "controls-position":
                                                        "right",
                                                      min: -999999999999,
                                                      max: 999999999999,
                                                      precision: 2,
                                                      disabled: true
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.billing
                                                          .taxFreeAmount,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.billing,
                                                          "taxFreeAmount",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "billing.taxFreeAmount"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_Remarks"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c("el-input", {
                                                attrs: {
                                                  type: "textarea",
                                                  no: "remark",
                                                  rows: 6
                                                },
                                                model: {
                                                  value: _vm.billing.remark,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "remark",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "billing.remark"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        [
                                          _c(
                                            "el-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_AccountContacts"
                                                    ),
                                                    "label-width": "105px;"
                                                  }
                                                },
                                                [
                                                  _c("cargo-advance-select", {
                                                    staticStyle: {
                                                      width: "200px"
                                                    },
                                                    attrs: {
                                                      "select-type":
                                                        _vm.selectTypeNames
                                                          .static_data_Contact,
                                                      "allow-create": true,
                                                      no: "accountContacts",
                                                      filterable: "",
                                                      cache: false,
                                                      clearable: "",
                                                      "default-value":
                                                        _vm.billing
                                                          .accountContacts,
                                                      "static-options":
                                                        _vm.accountContactsArray
                                                    },
                                                    on: {
                                                      parentCallBack:
                                                        _vm.accountContactChangeEvent
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 6 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_AccountContactsTel"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      no: "accountContactsTel"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.billing
                                                          .accountContactsTel,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.billing,
                                                          "accountContactsTel",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "billing.accountContactsTel"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-col",
                                            { attrs: { span: 8 } },
                                            [
                                              _c(
                                                "el-form-item",
                                                {
                                                  attrs: {
                                                    label: _vm.$t(
                                                      "CargoMsg.Cargo_AccountAddr"
                                                    )
                                                  }
                                                },
                                                [
                                                  _c("el-input", {
                                                    staticStyle: {
                                                      width: "100%"
                                                    },
                                                    attrs: {
                                                      no: "accountAddr"
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.billing.accountAddr,
                                                      callback: function($$v) {
                                                        _vm.$set(
                                                          _vm.billing,
                                                          "accountAddr",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "billing.accountAddr"
                                                    }
                                                  })
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "el-col",
                                        [
                                          _c(
                                            "el-form-item",
                                            { attrs: { "label-width": "0" } },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "CargoMsg.Cargo_InvoicingRequirements"
                                                    )
                                                  )
                                                )
                                              ]),
                                              _c("el-input", {
                                                attrs: {
                                                  type: "textarea",
                                                  no: "invoiceDemand",
                                                  rows: 6
                                                },
                                                model: {
                                                  value:
                                                    _vm.billing.invoiceDemand,
                                                  callback: function($$v) {
                                                    _vm.$set(
                                                      _vm.billing,
                                                      "invoiceDemand",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "billing.invoiceDemand"
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _vm.billingNoteContainInvoice
                                        ? _c("el-col", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  display: "flex",
                                                  width: "100%",
                                                  "padding-top": "10px"
                                                }
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "50%",
                                                      "padding-right": "5px"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t(
                                                            "Invoice.invoice_invoiceRemarks"
                                                          )
                                                        )
                                                      )
                                                    ]),
                                                    _c("el-input", {
                                                      attrs: {
                                                        type: "textarea",
                                                        no: "invoiceRemark",
                                                        rows: 6,
                                                        disabled: !_vm.billingNoteContainInvoiceChannel
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.billing
                                                            .invoiceRemark,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.billing,
                                                            "invoiceRemark",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "billing.invoiceRemark"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      width: "50%"
                                                    }
                                                  },
                                                  [
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.billingNoteContainInvoiceChannel
                                                            ? _vm.$t(
                                                                "CargoMsg.Cargo_RemarkAddContent3"
                                                              )
                                                            : _vm.$t(
                                                                "CargoMsg.Cargo_RemarkAddContent"
                                                              )
                                                        )
                                                      )
                                                    ]),
                                                    _c("el-input", {
                                                      attrs: {
                                                        type: "textarea",
                                                        no: "remarkAddContent",
                                                        rows: 6,
                                                        disabled:
                                                          _vm.billingNoteContainInvoiceChannel
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.billing
                                                            .remarkAddContent,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.billing,
                                                            "remarkAddContent",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "billing.remarkAddContent"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: {
                    "justify-content": "center",
                    "font-size": "30px"
                  }
                },
                [
                  _c("i", {
                    class: _vm.expandedGrid
                      ? "el-icon-caret-bottom"
                      : "el-icon-caret-top",
                    on: {
                      click: function($event) {
                        _vm.expandedGrid = !_vm.expandedGrid
                      }
                    }
                  })
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row",
                  staticStyle: { "justify-content": "space-between" }
                },
                [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.copyChargeHandler }
                        },
                        [
                          _vm._v(
                            _vm._s(this.$t("FinanceManage.charge_copyCharge"))
                          )
                        ]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.schemeBillChargeEvent }
                        },
                        [_vm._v(_vm._s(this.$t("FinanceManage.charge_sp7")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.addBillChargeEvent }
                        },
                        [_vm._v(_vm._s(this.$t("SeaExport.AddCharges")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "primary" },
                          on: { click: _vm.joinBillChargeEvent }
                        },
                        [_vm._v(_vm._s(this.$t("SeaExport.AddBillCharge")))]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { type: "danger" },
                          on: { click: _vm.removeBillChargeEvent }
                        },
                        [_vm._v(_vm._s(this.$t("SeaExport.RemoveBillCharge")))]
                      )
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "app-main-inner-row row-grid",
                  style: _vm.expandedGrid ? "flex-grow: 1;" : "height:300px"
                },
                [
                  _c("cargo-ag-grid", {
                    style: { width: "100%", height: "auto" },
                    attrs: {
                      "config-module": "1301254",
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveBilling()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_SaveGenerateBills")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function($event) {
                      return _vm.saveCharges()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_GenerateExpensesOnly")))]
              ),
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      return _vm.closeDialog()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("SeaExport.Cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.batchCheckingWindow.visible
        ? _c("batch-checking-window", {
            attrs: {
              visible: _vm.batchCheckingWindow.visible,
              lob: _vm.batchCheckingWindow.lob,
              jobs: _vm.batchCheckingWindow.jobs,
              "check-node": _vm.batchCheckingWindow.checkNode,
              "call-back": _vm.batchCheckingWindow.callBack,
              "call-back2": _vm.batchCheckingWindow.callBack2
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.batchCheckingWindow, "visible", $event)
              }
            }
          })
        : _vm._e(),
      _c("copy-charge-dialog", {
        attrs: {
          visible: _vm.copyChargeDialog.visible,
          lob: _vm.copyChargeDialog.lob,
          "is-sea": _vm.copyChargeDialog.isSea,
          receivable: _vm.copyChargeDialog.receivable,
          "receivable-disable": _vm.copyChargeDialog.receivableDisable,
          job: _vm.job
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyChargeDialog, "visible", $event)
          },
          selectedCopyChargeHandler: _vm.copyChargeRollBack
        }
      }),
      _c("charge-scheme-batch-dialog", {
        attrs: {
          visible: _vm.chargePlanDialog.visible,
          lob: _vm.chargePlanDialog.lob,
          "is-sea": _vm.chargePlanDialog.isSea,
          "original-condition": _vm.chargePlanDialog.originalCondition,
          "charge-scheme-is-approved":
            _vm.chargePlanDialog.chargeSchemeIsApproved,
          source: _vm.chargePlanDialog.source,
          job: _vm.job,
          receivable: _vm.chargePlanDialog.receivable,
          "receivable-disable": _vm.chargePlanDialog.receivableDisable
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.chargePlanDialog, "visible", $event)
          },
          selectedSchemeHandler: _vm.schemeChargeRollBack
        }
      }),
      _vm.joinChargeDialog.visible
        ? _c("join-charge-dialog", {
            ref: "joinChargeDialog",
            attrs: {
              visible: _vm.joinChargeDialog.visible,
              "search-item-module": "5042",
              "default-conditions": _vm.joinChargeDialog
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.joinChargeDialog, "visible", $event)
              },
              addChargeCallBackEvent: _vm.joinChargeCallBackEvent
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }